import styled from "styled-components";
import Input from "components/Input";

export const SearchInput = styled(Input).attrs(() => ({
  placeholder: "Digite o código da cotação",
  name: "BuscaOrigemRazaoSocialStatus",
  className: "bg-white w-100 quotesSearch"
}))``;